import React, { memo, useCallback } from 'react';
import { Box, Theme } from '@mui/material';
import { Icon, Button } from '@alycecom/ui';
import { useCopyToClipboard } from 'react-use';
import { GlobalMessage, MessageType } from '@alycecom/services';

const styles = {
  codeBlock: {
    px: 5,
    py: 1,
    mr: 1.75,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ({ palette }: Theme) => palette.grey.superLight,
    border: ({ palette }: Theme) => `1px dashed ${palette.grey.main}`,
    borderRadius: '5px',
    fontSize: 16,
    fontWeight: 'bold',
    color: ({ palette }: Theme) => palette.text.primary,
  },
  copyButton: {
    borderRadius: '5px',
  },
  icon: {
    mr: 1,
    fontSize: 16,
  },
} as const;

export interface ITangoCardCodeProps {
  code: string;
}

const TangoCardCode = ({ code }: ITangoCardCodeProps): JSX.Element => {
  const [, copyToClipBoard] = useCopyToClipboard();
  const { showGlobalMessage } = GlobalMessage.useGlobalMessage();

  const handleCopyCode = useCallback(() => {
    copyToClipBoard(code);
    showGlobalMessage({ text: 'Code is copied!', type: MessageType.Success });
  }, [code, copyToClipBoard, showGlobalMessage]);

  return (
    <Box display="flex">
      <Box sx={styles.codeBlock} data-testid="RedeemPage.Code.Value">
        {code}
      </Box>
      <Button
        sx={styles.copyButton}
        variant="contained"
        color="secondary"
        onClick={handleCopyCode}
        data-testid="RedeemPage.Code.CopyButton"
      >
        <Icon icon="copy" sx={styles.icon} /> Copy
      </Button>
    </Box>
  );
};

export default memo(TangoCardCode);
